<div class="card m-0">
  <div class="card-header">
    <div class="row align-items-center">
      <div class="col">
        <h6 class="m-0 fw-bold">New Conversation</h6>
      </div>
      <div class="col-auto">
        <button type="button" class="btn" (click)="modal.hide()">
          <i class="bx bx-x font-size-24"></i>
        </button>
      </div>
    </div>
  </div>

  <div class="card-body">
    <ng-container *ngIf="channel; else template">
      <div class="card h-100 m-0 shadow-none" *ngIf="channel.receiver as receiver">
        <div class="card-header">
          <div class="row g-2 flex-nowrap align-items-center">
            <div class="col-auto">
              <div [style.width]="'60px'">
                <div class="border border-secondary rounded-circle border-2 gallery-image">
                  <img
                    alt="..."
                    class="img-fluid rounded-circle"
                    src="https://dummyimage.com/200/ebebeb/bdbdbd.jpg?text=Unavailable"
                  />
                </div>
              </div>
            </div>
            <div class="col">
              <h4 class="m-0">{{ receiver.firstName }} {{ receiver.lastName }}</h4>
            </div>
          </div>
        </div>
        <div class="card-body d-flex flex-column">
          <ng-container *ngIf="channel.messages">
            <ngx-simplebar class="overflow-x-hidden simplebar-messages" #scrollRef>
              <div class="row">
                <ng-container *ngFor="let keyValue of channel.messages | keyvalue">
                  <ng-container *ngIf="keyValue.value as _message">
                    <div class="col-11" [ngClass]="{ 'ms-auto': _message.user._id === user!.id }">
                      <div
                        class="card"
                        [ngClass]="{
                          'card-light-primary': _message.user._id === user!.id,
                          'card-light': _message.user._id !== user!.id,
                        }"
                      >
                        <div class="card-body">
                          <div class="row g-2">
                            <div class="col-auto" [style.width]="'60px'">
                              <img
                                src="https://dummyimage.com/200/ebebeb/bdbdbd.jpg?text=Unavailable"
                                class="img-fluid rounded-circle"
                                alt="..."
                              />
                            </div>
                            <div class="col">
                              <h5 class="text-primary fw-bolder m-0">
                                {{ _message.user.name }}
                              </h5>
                              <p class="paragraph-truncate lines-2 m-0">
                                {{ _message.text }}
                              </p>
                              <p class="d-inline-block float-end m-0">
                                {{ _message.createdAt | timeAgo }}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </ng-container>
                </ng-container>
              </div>
            </ngx-simplebar>
          </ng-container>
        </div>

        <div class="card-footer bg-transparent">
          <form #form="ngForm" class="row" autocomplete="off" (ngSubmit)="ngSubmit()">
            <div class="input-group">
              <input
                class="form-control"
                type="text"
                autocomplete="off"
                id="message"
                name="message"
                #message="ngModel"
                placeholder="Type a message..."
                [(ngModel)]="model.message"
                [ngClass]="{
                  'is-invalid': submitted && message.invalid,
                }"
                required
              />
              <button type="submit" class="btn btn-light ms-0 text-primary">
                <i class="bx bxs-send"></i>
              </button>
            </div>
          </form>
        </div>
      </div>
    </ng-container>
    <ng-template #template>
      <app-application-users (emitter)="onConversation($event)"></app-application-users>
    </ng-template>
  </div>
</div>
